import { WebConfigAdd } from 'src/types/webConfig.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'helpdesk/web-configs';

export const getWebConfigs = async () => await http.get<WebConfigAdd[]>(controller);

export const addWebConfig = async (webConfig: WebConfigAdd[]) => await http.post<WebConfigAdd[]>(controller, webConfig);
